// extracted by mini-css-extract-plugin
module.exports = {"SectionTitle":"az_OMb","Title":"az_PMb","DesktopCta":"az_QMb"};